//lunr custom

var search_term = localStorage.getItem("search_all")
$('.search-full-text-form__input').val(search_term)

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g
};

$('#floatingCirclesG').show()

function callback_full(index, full_text) {

  $('#floatingCirclesG').hide()
  var browser = (function() {
    var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    console.log(ua)
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return ['IE', Number(tem[1]), ua]
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return [M[0], Number(M[1]), ua];
  })();

  console.log(browser);

  var index = lunr.Index.load(index[0])
  var search_input = $('.search-full-text-form__input')
  var search_result = $('.search-full-text-results')
  var search_button = $('.search-full-text-form__button')
  var search_pagination = $('.search-full-text-pagination')
  var ogdata = full_text[0]

  function displayResults() {
    // The value we're searching for
    var search = search_input.val();
    localStorage.setItem("search_all", search);

    var buildSearchResult = function(doc) {
      var li = document.createElement('li'),
        p = document.createElement('p')
      url = document.createElement('a')
      hr = document.createElement('hr')
      path_full = doc.path
      char_limit = 200

      p.dataset.field = 'text'
      p.textContent = doc.text.substring(0, char_limit) + ' ...'
      url.href = path_full
      url.dataset.field = 'title'
      url.textContent = doc.title

      li.appendChild(url)
      li.appendChild(p)
      li.appendChild(hr)
      return li
    }

    var results = index.search(search).map(function(result) {
      for (var key in ogdata) {
        if (ogdata.hasOwnProperty(key)) {
          //remapping index match to original data to get the full text
          if (ogdata[key].path == result.ref) {
            var doc = ogdata[key]
            var li = buildSearchResult(doc)
              //determine highlite
             Object.keys(result.matchData.metadata).forEach(function(term) {
               Object.keys(result.matchData.metadata[term]).forEach(function(fieldName) {
                 var field = li.querySelector('[data-field=' + fieldName + ']');
                 var positions = result.matchData.metadata[term][fieldName].position
                 var Safari_9 = (browser[0] === 'Safari' && browser[1] < 10)
                 var IE = browser[0] === 'IE'
                 var others = browser[0] == undefined
                 var mobile = browser[2].search('Mobi') > -1
                 if (!(Safari_9 || IE || others || mobile) ) {
                  wrapper(field, positions, char_limit)
                 }
               })
             })
          };
        }

      }
      return li
    });

    // Update the html based on the
    if (search) {
      if(results.length > 0){
        var results_chunks = _.chunk(results, 10)
        var pages = Math.min(10, results_chunks.length)

        var buildPagination = function(i) {
          var li = document.createElement('li'),
            a = document.createElement('a')
          a.textContent = i
          li.dataset.index = i
          li.appendChild(a)
            //activate the style of 1st li
          if (i === 1) {
            li.className = 'active'
          }
          return li
        }

        var renderPages = function(i) {
          results_chunks[i].map(function(result) {
            search_result.append(result);
          })
        }

        for (var i = 0; i < pages; i++) {
          search_pagination.append(buildPagination(i + 1))
        }

        renderPages(0)

        $('li[data-index]').click(function() {
          var page_index = $(this).attr('data-index')
          search_result.html('')
          $(this).addClass('active').siblings('li').removeClass('active')
          renderPages(page_index - 1)
        })
      }else{
        search_result.html('<li>No matches. Please try searching again.</li>');
      }

    }
   }

  $(function() {
    // List the initial characters
    displayResults();

    // search only when search button is clicked
    search_button.click(function() {
      search_result.html('')
      search_pagination.html('')
      displayResults();
    })
  });

}
